// src/components/ShortUrlSection/ShortUrlSection.js
import React, { useState } from 'react';
import Modal from 'react-modal';
import './ShortUrlSection.css';

const ShortUrlSection = () => {
  // Dummy veriler: 5-6 örnek URL
  const initialData = [
    { id: 1, originalUrl: 'https://www.instagram.com/someuser', shortUrl: 'short.ly/abc123', date: '2023-04-10' },
    { id: 2, originalUrl: 'https://www.youtube.com/watch?v=xyz789', shortUrl: 'short.ly/def456', date: '2023-04-11' },
    { id: 3, originalUrl: 'https://www.facebook.com/somepage', shortUrl: 'short.ly/ghi789', date: '2023-04-12' },
    { id: 4, originalUrl: 'https://twitter.com/someuser', shortUrl: 'short.ly/jkl012', date: '2023-04-13' },
    { id: 5, originalUrl: 'https://www.linkedin.com/in/someprofile', shortUrl: 'short.ly/mno345', date: '2023-04-14' },
    { id: 6, originalUrl: 'https://www.tiktok.com/@someuser', shortUrl: 'short.ly/pqr678', date: '2023-04-15' },
  ];
  
  const [urlList, setUrlList] = useState(initialData);
  const [newUrl, setNewUrl] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  
  // URL'yi kısaltma işlemini simüle eden fonksiyon (dummy shortening)
  const shortenUrl = (url) => {
    const randomString = Math.random().toString(36).substring(2, 8);
    return `short.ly/${randomString}`;
  };

  const addUrl = (e) => {
    e.preventDefault();
    if (newUrl.trim() === '') return;
    const shortUrl = shortenUrl(newUrl);
    const currentDate = new Date().toISOString().split('T')[0]; // YYYY-MM-DD formatında
    const newEntry = {
      id: urlList.length + 1,
      originalUrl: newUrl,
      shortUrl: shortUrl,
      date: currentDate
    };
    setUrlList([...urlList, newEntry]);
    setNewUrl('');
  };

  const openModal = (row) => {
    setSelectedRow(row);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setSelectedRow(null);
    setModalIsOpen(false);
  };

  return (
    <div className="shorturl-section">
      <h2>Kısa URL Oluştur</h2>
      <div className="add-url-form">
        <form onSubmit={addUrl}>
          <input 
            type="text" 
            placeholder="URL giriniz" 
            value={newUrl}
            onChange={(e) => setNewUrl(e.target.value)}
          />
          <button type="submit">Kısalt</button>
        </form>
      </div>
      <table className="shorturl-table">
        <thead>
          <tr>
            <th>Orijinal URL</th>
            <th>Kısa URL</th>
            <th>Eklenme Tarihi</th>
            <th>Detay</th>
          </tr>
        </thead>
        <tbody>
          {urlList.map(row => (
            <tr key={row.id}>
              <td>{row.originalUrl}</td>
              <td>{row.shortUrl}</td>
              <td>{row.date}</td>
              <td>
                <button onClick={() => openModal(row)}>Detay</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      
      <Modal 
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="URL Detay"
        className="modal"
        overlayClassName="modal-overlay"
      >
        {selectedRow ? (
          <div>
            <h2>URL Detayları</h2>
            <p><strong>Orijinal URL:</strong> {selectedRow.originalUrl}</p>
            <p><strong>Kısa URL:</strong> {selectedRow.shortUrl}</p>
            <p><strong>Eklenme Tarihi:</strong> {selectedRow.date}</p>
          </div>
        ) : (
          <div>
            <h2>Yeni URL Ekle</h2>
            <p>Formu doldurunuz.</p>
          </div>
        )}
        <button className='modal-close' onClick={closeModal}>x</button>
      </Modal>
    </div>
  );
};

export default ShortUrlSection;
